<template>
    <div style="width: 100%; height: 100%; display: flex;">
        <div>
            <button @click="print">打印</button>
        </div>
        <div style="flex-grow: 1;">
            <iframe ref="myIframe" :src="`/api/admin/mall/jcy/orderSend/${id}`" frameborder="0" style="width: 100%; height: 100%; overflow: hidden;" v-if="id"></iframe>
        </div>
    </div>
</template>
<script>
export default {
    name: "DeliveryNote",
    data() {
        return {
            id: null,
        }
    },
    methods: {
        init() {
            // this.fetchRegion();
            const { id } = this.$route.query;
            this.id = id;
            // this.query(id);
        },
        // query(id) {
        //     this.$axios.get(`/admin/mall/jcy/orderSend/${id}`).then(res => {
        //         console.log(res.data);
        //     })

        // },
        print() {
            // 通过ref获取iframe元素
            const iframe = this.$refs.myIframe;
            if (iframe && iframe.contentWindow) {
                try {
                // 调用iframe内部的打印方法
                iframe.contentWindow.print();
                } catch (e) {
                console.error('打印失败:', e);
                }
            }
        }
    },
    created() {
        this.init();
    },
}
</script>